<template>
  <div class="homePage">
    <Loader v-if="loading" />
    <div v-else>
      <NoData v-if="noData" />

      <div class="" ref="main_wrapper" v-else>
        <!--Start First row -->
        <div class="row">
          <div class="col-lg-8">
            <simple-card classes="p-0 w-100 h-100" v-if="monthsstatistics">
              <h6 class="col-12">{{ $t("labels.months_statistics") }}</h6>
              <div class="row">
                <div
                  class="col-6 col-md-4"
                  v-if="monthsstatistics.total_orders"
                >
                  <home-card
                    :item="monthsstatistics.total_orders"
                    :route="`/order/show-all?get_data_by=this_month`"
                    :color="getRandomColor(colors)"
                  />
                </div>
                <div
                  class="col-6 col-md-4"
                  v-if="monthsstatistics.pending_orders"
                >
                  <home-card
                    :item="monthsstatistics.pending_orders"
                    :route="`/order/show-all?status=pending&get_data_by=this_month`"
                    :color="getRandomColor(colors)"
                  />
                </div>
                <div
                  class="col-6 col-md-4"
                  v-if="monthsstatistics.completed_orders"
                >
                  <home-card
                    :item="monthsstatistics.completed_orders"
                    :route="`/order/show-all?status=admin_delivered&get_data_by=this_month`"
                    :color="getRandomColor(colors)"
                  />
                </div>
                <div
                  class="col-6 col-md-4"
                  v-if="monthsstatistics.canceled_orders"
                >
                  <home-card
                    :item="monthsstatistics.canceled_orders"
                    :route="`/order/show-all?status=client_cancel&get_data_by=this_month`"
                    :color="getRandomColor(colors)"
                  />
                </div>
                <div
                  class="col-6 col-md-4"
                  v-if="monthsstatistics.total_revenue"
                >
                  <home-card
                    :item="monthsstatistics.total_revenue"
                    :route="`/`"
                    :color="getRandomColor(colors)"
                  />
                </div>
                <div class="col-6 col-md-4" v-if="monthsstatistics.cart">
                  <home-card
                    :item="monthsstatistics.cart"
                    :route="'/cart/show-all?get_data_by=this_month'"
                    :color="getRandomColor(colors)"
                  />
                </div>
                <div class="col-6 col-md-4" v-if="monthsstatistics.withdrawal">
                  <home-card
                    :item="monthsstatistics.withdrawal"
                    :route="'/withdrawal/show-all'"
                    :color="getRandomColor(colors)"
                  />
                </div>
                <div
                  class="col-6 col-md-4"
                  v-if="monthsstatistics.total_offers"
                >
                  <home-card
                    :item="monthsstatistics.total_offers"
                    :route="'/offer/show-all?get_data_by=this_month'"
                    :color="getRandomColor(colors)"
                  />
                </div>
                <div
                  class="col-6 col-md-4"
                  v-if="monthsstatistics.total_flash_sale"
                >
                  <home-card
                    :item="monthsstatistics.total_flash_sale"
                    :route="'/flash-sale/show-all?get_data_by=this_month'"
                    :color="getRandomColor(colors)"
                  />
                </div>
              </div>
            </simple-card>
          </div>
          <div class="col-lg-4">
            <simple-card classes="w-100 h-100" v-if="best_seller">
              <div class="h-full">
                <AreaCharts
                  dir="ltr"
                  ChartHeigh="320px !important"
                  :ShapeType="'area'"
                  :ChartType="'smooth'"
                  :ChartColors="['#ffb427', '#ffb427']"
                  :ChartLabels="revenue_month_chart.labels.map((x) => x.day)"
                  :ChartData="revenue_month_chart.series"
                >
                  <template #chart_title>
                    <span class="title_text">
                      {{ $t("labels.monthSales") }}
                    </span>
                  </template>
                </AreaCharts>
              </div>
            </simple-card>
          </div>
        </div>
        <!--End First row -->
        <!--Start Second row -->
        <div class="row">
          <div class="col-lg-8">
            <simple-card classes="p-0 w-100 h-100" v-if="generalSummary">
              <h6 class="col-12">{{ $t("labels.general_statistics") }}</h6>

              <div class="row" v-if="generalSummary">
                <div class="col-6 col-md-4" v-if="generalSummary.total_orders">
                  <home-card
                    :item="generalSummary.total_orders"
                    :route="`/order/show-all`"
                    :color="getRandomColor(colors)"
                  />
                </div>
                <div
                  class="col-6 col-md-4"
                  v-if="generalSummary.total_products"
                >
                  <home-card
                    :item="generalSummary.total_products"
                    :route="`/products/show-all`"
                    :color="getRandomColor(colors)"
                  />
                </div>

                <div class="col-6 col-md-4" v-if="generalSummary.clients">
                  <home-card
                    :item="generalSummary.clients"
                    :route="`/client/show-all`"
                    :color="getRandomColor(colors)"
                  />
                </div>
                <div class="col-6 col-md-4" v-if="generalSummary.categories">
                  <home-card
                    :item="generalSummary.categories"
                    :route="`/categories/show-all`"
                    :color="getRandomColor(colors)"
                  />
                </div>
                <!-- <div class="col-6 col-md-4" v-if="generalSummary.sliders">
                  <home-card
                    :item="generalSummary.sliders"
                    :route="`/slider/show-all`"
                    :color="getRandomColor(colors)"
                  />
                </div> -->
                <div
                  class="col-6 col-md-4"
                  v-if="generalSummary.product_stocks"
                >
                  <home-card
                    :item="generalSummary.product_stocks"
                    :route="`/stock-tracking/show-all`"
                    :color="getRandomColor(colors)"
                  />
                </div>
                <div class="col-6 col-md-4" v-if="generalSummary.rates">
                  <home-card
                    :item="generalSummary.rates"
                    :route="`/rates/show-all`"
                    :color="getRandomColor(colors)"
                  />
                </div>
              </div>
            </simple-card>
          </div>
          <div class="col-lg-4">
            <div class="row">
              <div class="col-lg-12 col-md-6">
                <simple-card classes="w-100 h-100" v-if="best_seller">
                  <div class="best_seller_card">
                    <div
                      class="d-flex align-items-start justify-content-between py-3"
                    >
                      <div class="mx-1">
                        <h5 class="fs-6">{{ $t("labels.best_seller") }}</h5>
                        <p>
                          {{ best_seller && best_seller.fullname }}
                        </p>
                        <div>
                          <router-link
                            :to="`/client/show/${best_seller.id}`"
                            class="btn mt-4"
                          >
                            {{ $t("labels.view_details") }}
                          </router-link>
                        </div>
                      </div>
                      <img
                        width="100"
                        height="120"
                        class="avatar-img"
                        src="@/assets/media/images/card-advance-sale.png"
                        alt=""
                      />
                    </div>
                  </div>
                </simple-card>
              </div>
              <div class="col-lg-12 col-md-6">
                <simple-card
                  classes=" w-100 h-100"
                  v-if="most_sale_product.length"
                >
                  <div class="best_seller_card">
                    <div
                      class="d-flex align-items-start justify-content-between py-3"
                    >
                      <div class="mx-1">
                        <h5 class="fs-6">{{ $t("labels.best_product") }}</h5>

                        <p class="displya-6">
                          {{ most_sale_product[0]?.product?.name }}
                        </p>

                        <div>
                          <router-link
                            :to="`/products/show/${most_sale_product[0]?.product?.id}`"
                            class="btn mt-4"
                          >
                            {{ $t("labels.view_details") }}
                          </router-link>
                        </div>
                      </div>
                      <img
                        width="100"
                        height="120"
                        class="avatar-img"
                        :src="most_sale_product[0]?.product?.image"
                        alt="produc-image"
                      />
                    </div>
                  </div>
                </simple-card>
              </div>
            </div>
          </div>
        </div>
        <!--End Second row -->
        <!--Start Third row -->
        <div class="row">
          <!-- recentOrders -->
          <div class="col-lg-4">
            <simple-card classes="p-0 w-100 h-100">
              <div class="col-12 products_states client">
                <header>
                  <h2 class="title">
                    {{ $t("labels.recentOrders") }}
                  </h2>
                </header>

                <div class="content" v-if="recent_orders.length">
                  <div
                    class="product_card"
                    v-for="item in recent_orders"
                    :key="item.id"
                  >
                    <router-link :to="`/order/show/${item.id}`">
                      <div class="align-items-start border-bottom pb-1 state">
                        <div class="icon">
                          <img
                            width="55"
                            height="55"
                            class="rounded-lg"
                            :src="item.client.avatar"
                            alt=""
                          />
                        </div>

                        <div
                          class="product_content d-flex align-items-center justify-content-between"
                        >
                          <div>
                            <p class="quantity">
                              <bdi>
                                <span> {{ item && item.client.fullname }}</span>
                              </bdi>
                            </p>
                            <p class="quantity">
                              <bdi>
                                {{ $t("labels.payment_status") }}
                              </bdi>
                              <bdi>
                                <span
                                  :class="
                                    item && item.is_payment
                                      ? `active`
                                      : `inactive`
                                  "
                                  >{{
                                    item && item.is_payment
                                      ? `${$t("status.isPaid")}`
                                      : `${$t("status.isNotPaid")}`
                                  }}</span
                                >
                              </bdi>
                            </p>
                            <p class="quantity">
                              <bdi>
                                {{ $t("labels.status") }}
                              </bdi>
                              <bdi>
                                <span>{{ item && item.status_trans }}</span>
                              </bdi>
                            </p>
                          </div>
                          <div class="text-center">
                            <p class="quantity">
                              <bdi>
                                {{ $t("labels.quantity") }}
                              </bdi>
                              <bdi>
                                <span>{{
                                  item && item.total_quantity_product
                                }}</span>
                              </bdi>
                            </p>
                            <p class="price">
                              <bdi>
                                <span>{{ item && item.total_price }} </span>
                              </bdi>
                            </p>
                            <p>
                              <bdi>
                                <span> {{ $t("appCurrency") }} </span>
                              </bdi>
                            </p>
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
                <span
                  class="redColor mt-4 fs-6 text-center d-block fontBold"
                  v-else
                >
                  {{ $t("notFound") }}</span
                >
                <footer>
                  <router-link to="/stock-tracking/show-all">
                    {{ $t("breadcrumb.orders.all") }}
                  </router-link>
                </footer>
              </div>
            </simple-card>
          </div>
          <!-- productsOutOfStock -->
          <div class="col-lg-4">
            <simple-card classes="p-0 w-100 h-100">
              <div class="col-12 products_states client">
                <header>
                  <h2 class="title">
                    {{ $t("labels.productsOutOfStock") }}
                  </h2>
                </header>

                <div class="content" v-if="products_out_of_stock.length">
                  <div
                    class="product_card"
                    v-for="item in top_product"
                    :key="item.id"
                  >
                    <router-link
                      :to="`/products/show/${item.product && item.product.id}`"
                    >
                      <div class="align-items-start border-bottom pb-1 state">
                        <div class="icon">
                          <img
                            width="55"
                            height="55"
                            class="rounded-lg"
                            :src="item.product && item.product.image"
                            alt=""
                          />
                        </div>

                        <div
                          class="product_content d-flex align-items-center justify-content-between"
                        >
                          <div>
                            <h5 class="title">
                              {{ item.product && item.product.name }}
                            </h5>
                            <p class="quantity">
                              <bdi>
                                {{ $t("labels.quantity") }}
                              </bdi>
                              <bdi>
                                <span>{{ item && item.quantity }}</span>
                              </bdi>
                            </p>
                          </div>
                          <div class="text-center">
                            <p class="price">
                              <bdi>
                                <span>{{ item && item.price }}</span>
                              </bdi>
                            </p>
                            <p>
                              <bdi>
                                <span> {{ $t("appCurrency") }} </span>
                              </bdi>
                            </p>
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
                <span
                  class="redColor mt-4 fs-6 text-center d-block fontBold"
                  v-else
                >
                  {{ $t("notFound") }}</span
                >
                <footer>
                  <router-link to="/stock-tracking/show-all">
                    {{ $t("breadcrumb.orders.all") }}
                  </router-link>
                </footer>
              </div>
            </simple-card>
          </div>
          <!--most_sales_products  -->
          <div class="col-lg-4">
            <simple-card classes="p-0 w-100 h-100">
              <div class="col-12 products_states client">
                <header>
                  <h2 class="title">
                    {{ $t("most_sales_products") }}
                  </h2>
                </header>

                <div class="content" v-if="most_sale_products.length">
                  <div
                    class="product_card"
                    v-for="item in most_sale_products"
                    :key="item.id"
                  >
                    <router-link
                      :to="`/products/show/${item.product && item.product.id}`"
                    >
                      <div class="align-items-start border-bottom pb-1 state">
                        <div class="icon">
                          <img
                            width="55"
                            height="55"
                            class="rounded-lg"
                            :src="item.product && item.product.image"
                            alt=""
                          />
                        </div>

                        <div
                          class="product_content d-flex align-items-center justify-content-between"
                        >
                          <div>
                            <h5 class="title">
                              {{ item.product && item.product.name }}
                            </h5>
                            <p class="quantity">
                              <bdi>
                                {{ $t("labels.quantity") }}
                              </bdi>
                              <bdi>
                                <span>{{ item && item.quantity }}</span>
                              </bdi>
                            </p>
                          </div>

                          <div class="text-center">
                            <p class="price">
                              <bdi>
                                <span>{{ item && item.price }}</span>
                              </bdi>
                            </p>
                            <p>
                              <bdi>
                                <span> {{ $t("appCurrency") }} </span>
                              </bdi>
                            </p>
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
                <span
                  class="redColor mt-4 fs-6 text-center d-block fontBold"
                  v-else
                >
                  {{ $t("notFound") }}</span
                >
                <footer>
                  <router-link to="/stock-tracking/show-all">
                    {{ $t("breadcrumb.orders.all") }}
                  </router-link>
                </footer>
              </div>
            </simple-card>
          </div>
        </div>

        <!--End Third row -->
        <!--Start Forth row -->
        <div class="row">
          <!-- Top Products -->
          <div class="col-lg-4">
            <simple-card classes="p-0 w-100 h-100">
              <div class="col-12 products_states client">
                <header>
                  <h2 class="title">
                    {{ $t("labels.topProducts") }}
                  </h2>
                </header>

                <div class="content" v-if="top_product.length">
                  <div
                    class="product_card"
                    v-for="item in top_product"
                    :key="item.id"
                  >
                    <router-link
                      :to="`/products/show/${item.product && item.product.id}`"
                    >
                      <div class="align-items-start border-bottom pb-2 state">
                        <div class="icon">
                          <img
                            width="55"
                            height="55"
                            class="rounded-lg"
                            :src="item.product && item.product.image"
                            alt=""
                          />
                        </div>

                        <div
                          class="product_content d-flex align-items-center justify-content-between"
                        >
                          <div>
                            <h5 class="title">
                              {{ item.product && item.product.name }}
                            </h5>
                            <p class="quantity">
                              <bdi>
                                {{ $t("labels.quantity") }}
                              </bdi>
                              <bdi>
                                <span>{{ item.quantity }}</span>
                              </bdi>
                            </p>
                          </div>

                          <div class="text-center">
                            <p class="price">
                              <bdi>
                                <span>{{ item && item.price }}</span>
                              </bdi>
                            </p>
                            <p>
                              <bdi>
                                <span> {{ $t("appCurrency") }} </span>
                              </bdi>
                            </p>
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
                <span
                  class="redColor mt-4 fs-6 text-center d-block fontBold"
                  v-else
                >
                  {{ $t("notFound") }}
                </span>
                <footer>
                  <router-link to="/products/show-all">
                    {{ $t("breadcrumb.orders.all") }}
                  </router-link>
                </footer>
              </div>
            </simple-card>
          </div>
          <!-- recentReviews -->
          <div class="col-lg-4">
            <simple-card classes="p-0 w-100 h-100">
              <div class="col-12 products_states client">
                <header>
                  <h2 class="title">
                    {{ $t("labels.recentReviews") }}
                  </h2>
                </header>

                <div class="content" v-if="recent_reviews.length">
                  <div
                    class="product_card"
                    v-for="item in recent_reviews"
                    :key="item.id"
                  >
                    <router-link :to="`/rates/show/${item.id}`">
                      <div class="align-items-start border-bottom pb-1 state">
                        <div class="icon">
                          <img
                            width="55"
                            height="55"
                            class="rounded-lg"
                            :src="user?.image"
                            alt=""
                          />
                        </div>

                        <div
                          class="product_content d-flex align-items-center justify-content-between"
                        >
                          <div>
                            <p class="quantity">
                              <bdi>
                                <span> {{ item?.user?.fullname }}</span>
                              </bdi>
                            </p>
                            <p class="quantity">
                              <bdi> {{ $t("labels.comment") }} : </bdi>
                              <bdi>
                                <span>{{ item.comment }}</span>
                              </bdi>
                            </p>
                            <p class="quantity">
                              <bdi>
                                {{ $t("labels.status") }}
                              </bdi>
                              <bdi>
                                <span
                                  :class="
                                    item && item.status == 'accepted'
                                      ? `active`
                                      : `inactive`
                                  "
                                  >{{ item.status_trans }}</span
                                >
                              </bdi>
                            </p>
                          </div>
                          <div class="text-center">
                            <v-rating
                              readonly
                              length="5"
                              color="yellow"
                              size="15"
                              :value="item.rate"
                            ></v-rating>
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
                <span
                  class="redColor mt-4 fs-6 text-center d-block fontBold"
                  v-else
                >
                  {{ $t("notFoundReviews") }}</span
                >
                <footer v-if="recent_reviews.length">
                  <router-link to="/rates/show-all">
                    {{ $t("breadcrumb.orders.all") }}
                  </router-link>
                </footer>
              </div>
            </simple-card>
          </div>
          <!-- transfer_requests -->
          <div class="col-lg-4">
            <simple-card classes="p-0 w-100 h-100">
              <div class="col-12 products_states client">
                <header>
                  <h2 class="title">
                    {{ $t("labels.transferRequests") }}
                  </h2>
                </header>

                <div class="content" v-if="transfer_requests.length">
                  <div
                    class="product_card"
                    v-for="item in transfer_requests"
                    :key="item.id"
                  >
                    <router-link :to="`/withdrawal/show-all`">
                      <div class="align-items-start border-bottom pb-2 state">
                        <div class="icon">
                          <img
                            width="55"
                            height="55"
                            class="rounded-lg"
                            :src="item.client && item.client.avatar"
                            alt=""
                          />
                        </div>

                        <div
                          class="product_content d-flex align-items-center justify-content-between"
                        >
                          <div>
                            <h5 class="title">
                              {{ item.client && item.client.fullname }}
                            </h5>
                            <p class="quantity">
                              <bdi>
                                {{ $t("labels.bank_name") }}
                              </bdi>
                              <bdi>
                                <span>{{ item.bank_name }}</span>
                              </bdi>
                            </p>
                            <p class="quantity">
                              <bdi> {{ $t("labels.status") }} : </bdi>
                              <bdi>
                                <span>{{ $t(`status.${item.status}`) }}</span>
                              </bdi>
                            </p>
                          </div>

                          <div class="text-center">
                            <p class="price">
                              <bdi>
                                <span>{{ item && item.amount }}</span>
                              </bdi>
                            </p>
                            <p>
                              <bdi>
                                <span> {{ $t("appCurrency") }} </span>
                              </bdi>
                            </p>
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
                <span
                  class="redColor mt-4 fs-6 text-center d-block fontBold"
                  v-else
                >
                  {{ $t("notFoundWithdrawal") }}
                </span>
                <footer v-if="transfer_requests.length">
                  <router-link to="/products/show-all">
                    {{ $t("breadcrumb.orders.all") }}
                  </router-link>
                </footer>
              </div>
            </simple-card>
          </div>
        </div>
        <!--End Forth row -->

        <!--Start last row -->
        <div class="row mb-10">
          <div class="col-lg-12">
            <simple-card classes="p-0 w-100 h-100" v-if="revenue_chart">
              <div class="col-12 h-full">
                <AreaCharts
                  dir="ltr"
                  ChartHeigh="320px !important"
                  :ShapeType="'area'"
                  :ChartType="'smooth'"
                  :ChartColors="['#ffb427', '#ffb427']"
                  :ChartLabels="revenue_chart.labels.map((x) => x.month_name)"
                  :ChartData="revenue_chart.series"
                >
                  <template #chart_title>
                    <span class="title_text">
                      {{ $t("labels.annualSales") }}
                    </span>
                  </template>
                </AreaCharts>
              </div>
            </simple-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChartsAside from "@/components/Layouts/ChartsAside.vue";
import Loader from "@/components/Loaders/loader.vue";
import AreaCharts from "@/components/Charts/AreaCharts.vue";
import ColumnChart from "@/components/Charts/ColumnChart.vue";

export default {
  name: "HomePage",

  components: {
    ChartsAside,
    AreaCharts,
    ColumnChart,
    Loader,
  },

  data() {
    return {
      colors: [
        {
          first: "#62EAE1",
          second: "rgba(126, 229, 223, 0)",
        },
        {
          first: "#FF6370",
          second: "rgba(255, 99, 112, 0)",
        },
        {
          first: "#9E62EA",
          second: " #B199ED",
        },
        {
          first: "#EABC62",
          second: "#E9BA62",
        },
      ],

      button_: {
        id: "",
      },
      // ========== Charts Aside
      asideIsActive: false,
      // start of main loader
      noData: true,
      loading: false,
      // end of main loader
      // ============ Charts Data
      cards: [],
      notifications_states: [],
      charts: [],
      order_status: null,
      recent_reviews: [],
      top_cards: [],
      recently_partner: [],
      recently_rider: [],
      top_vehicle_package: [],
      recent_orders: [],
      top_product: [],
      products_out_of_stock: [],
      most_sale_products: [],
      most_sale_product: [],
      transfer_requests: [],
      chartsData: null,
      revenue_chart: null,
      revenue_month_chart: null,
      best_seller: null,
      monthsstatistics: null,
      generalSummary: null,
      top_recent_orders_headers: [
        {
          text: this.$t("labels.order_number"),
          value: "order_number",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("labels.date"),
          value: "created_at",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("labels.customer"),
          value: "client",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("labels.price"),
          value: "total_price",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("labels.quantity"),
          value: "total_quantity_product",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("labels.is_payment"),
          value: "is_payment",
          align: "center",
          sortable: false,
        },

        {
          text: this.$t("labels.status"),
          value: `status_trans`,
          align: "center",
          sortable: true,
        },

        {
          text: this.$t("labels.control"),
          value: "actions",
          align: "center",
          sortable: false,
        },
      ],
      transfer_requests_headers: [
        {
          text: "#",
          value: "index",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("labels.rider"),
          value: "user_name",
          align: "center",
        },

        {
          text: this.$t("labels.amount"),
          value: "amount",
          align: "center",
        },
        {
          text: this.$t("labels.bank_name"),
          value: "bank_name",
          align: "center",
        },
        {
          text: this.$t("labels.account_number"),
          value: "account_number",
          align: "center",
        },
        {
          text: this.$t("labels.ibanNumber"),
          value: "iban",
          align: "center",
        },
        {
          text: this.$t("labels.created_at"),
          value: "created_at",
          align: "center",
        },
        {
          text: this.$t("labels.status"),
          value: "status",
          align: "center",
        },
        {
          text: this.$t("labels.accept_reject"),
          value: "accept_reject",
          align: "center",
        },
      ],
    };
  },
  computed: {
    user() {
      return this.$store.getters["auth_module/currentUser"];
    },
  },

  methods: {
    toggleAside() {
      this.asideIsActive = !this.asideIsActive;
    },
    getRouteLink(item) {
      let link;
      if (item.notify_type == "order") {
        link = "order";
      } else if (item.notify_type == "new_rider") {
        link = "riders";
      } else if (item.notify_type == "new_partner") {
        link = "partners";
      } else if (item.notify_type == "finish_trip") {
        link = "trips";
      }

      return link;
    },
    getHome() {
      this.canShow = this.$permission.allowed("home/show-all");
      if (!this.canShow) {
        this.loading = true;
        this.noData = false;
        this.axios({
          method: "GET",
          url: "/home",
        })
          .then((res) => {
            this.noData = false;
            this.cards = res.data.data.upper_chart;
            this.notifications_states = res.data.data.notifications;
            this.top_cards = res.data.data.top_selling_product_chart;
            this.revenue_chart = res.data.data.revenue_chart;
            this.revenue_month_chart = res.data.data.revenue_month_chart;
            this.best_seller = res.data.data.best_seller;
            this.monthsstatistics = res.data.data.monthsstatistics;
            this.generalSummary = res.data.data.generalSummary;

            this.order_status = res.data.data.order_status;
            this.recent_reviews = res.data.data.recent_reviews;
            this.top_product = res.data.data.top_product;
            this.products_out_of_stock = res.data.data.products_out_of_stock;
            this.most_sale_product = res.data.data.most_sale_product;
            this.most_sale_products = res.data.data.most_sale_products;
            this.recent_orders = res.data.data.recent_orders;
            this.transfer_requests = res.data.data.transfer_requests;

            this.loading = false;
          })
          .catch((err) => {
            this.noData = true;
            this.loading = false;
            this.$iziToast.error({
              displayMode: 2,
              title: this.$t("error"),
              message:
                err.response?.data.message ?? err.response?.data.messages,
            });
          });
      }
    },

    getRandomColor(colors) {
      let random = Math.floor(Math.random() * 4);

      return { colors: colors[random], id: random };
    },

    imageError(index, inp) {
      this[inp][
        index
      ].avatar = require("@/assets/media/images/Icons/no-data.png");
    },

    getPermissions() {
      this.axios.get("get_my_permissions").then((res) => {
        localStorage.setItem(
          "alalmiyaae_Dash_permissions",
          JSON.stringify(res.data.data)
        );
        this.getHome();
        this.getSideBar();
      });
    },

    getControls() {
      this.axios
        .get("get_my_control_permissions")
        .then((res) =>
          localStorage.setItem("alalmiyaae_controls", JSON.stringify(res.data.data))
        );
    },

    getSideBar() {
      this.axios.get("admin_side_bar").then((res) => {
        this.$router.push(`/${res.data[0].categories[0].permissions[0].url}`);
      });
    },

    changeStatus(item, status) {
      const frmData = new FormData();
      this.button_.id = item.id;

      frmData.append("_method", "PUT");
      frmData.append("status", status);
      // if (status == "rejected") {
      //   frmData.append("rejected_reason", data.rejected_reason);
      // }
      this.axios
        .post(`/wallet/withdraw/${item.id}`, frmData)
        .then(() => {
          this.button_.id = "";
          this.$iziToast.success({
            title: this.$t("success"),
            displayMode: 2,
            message:
              status == "accepted" ? "تمت الموافقة بنجاح" : "تمت رفض السحب ",
          });

          this.setRows();
        })
        .catch((err) => {
          this.button_.id = "";
          this.$iziToast.error({
            title: this.$t("error"),
            displayMode: 2,
            message: err.response?.data.message ?? err.response?.data.messages,
          });
        });
    },
  },

  created() {
    this.canShow = this.$permission.allowed("home/show-all");

    if (this.user.usertype != "superadmin") {
      if (!this.canShow) {
        this.getHome();
      }
    } else {
      this.getHome();
      if (localStorage.getItem("alalmiyaae_Dash_permissions")) {
        localStorage.removeItem("alalmiyaae_Dash_permissions");
      }
    }
  },
};
</script>

<style lang="scss">
.best_seller_card {
  position: relative;

  .avatar-img {
    position: absolute !important;
    inset-inline-end: 0.5rem !important;
    max-width: 120px;

    top: 0 !important;
    bottom: 0 !important;
  }
  .title {
    font-style: normal;
    font-weight: 600;
    font-size: 18px !important;
    line-height: 20px;
    color: #000;
    // padding: 10px 0;
  }

  p {
    font-style: normal;
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 17px;
    width: 80%;
    color: var(--mainText) !important;
    margin: 0;
  }
  a.btn {
    background: linear-gradient(
      97.46deg,
      #3665B0 -1.53%,
      #3665B0 132.35%
    ) !important;
    color: #fff !important;
    padding-block: 5px;
    width: fit-content;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    opacity: 1;
    font-size: 14px;
    &:hover {
      opacity: 0.8;
    }
  }
}

.homeTable {
  .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > thead
    > tr:last-child
    > th {
    text-align: start !important;

    &:last-child {
      text-align: center !important;
    }
  }

  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
  .v-data-table > .v-data-table__wrapper > table > thead > tr > td,
  .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    text-align: start !important;
  }

  .ordersLink {
    color: var(--main) !important;
    // font-size: 16px !important;
  }

  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
  .v-data-table > .v-data-table__wrapper > table > thead > tr > td,
  .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    text-align: center !important;
  }
}
.client_order {
  .title {
    display: block;
    font-style: normal;
    font-weight: 300 !important;
    font-size: 15.5px !important;
    line-height: 17px;
    color: #666666;
    margin: 0;
    margin-bottom: 5px;
  }
  .email {
    font-size: 0.8rem !important;
    font-weight: 400;
    color: #2b3d2f !important;
    line-height: 1.375rem;
    letter-spacing: normal !important;
    text-transform: none !important;
  }
}
.stats_chart {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-start;
  // justify-content: space-c;
  padding: 15px;
  // flex-direction: row-reverse;
  .icon {
    width: 50px;
    height: 50px;

    display: flex;
    justify-content: center;
    align-items: center;
    margin-inline-end: 0.5rem;
  }
  .content {
    display: flex;
    flex-direction: column;
    .value {
      font-style: normal;
      font-weight: 500;
      // font-size: 16px;

      color: #000;
    }
    .name {
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 18px;
      margin-bottom: 4px;
      color: var(--mainText);
    }
    .values {
      margin-top: 0.5rem;
      span {
        color: var(--main);
        font-weight: 700;
        font-size: 1rem;
      }
    }
  }
}
.notifications_states {
  header {
    border-bottom: 1px solid #efefef !important;
    .title {
      font-style: normal;
      font-weight: 400;
      font-size: 15px !important;
      line-height: 20px;
      color: #000;
    }
  }
  .content {
    min-height: 200px;
    max-height: 350px;
    overflow-y: auto;
    padding-block: 8px;
    .notification_card {
      .state {
        display: flex;
        align-items: center;
        .notification_content {
          margin-inline-start: 8px;
          .title {
            display: block;
            font-style: normal;
            font-weight: 400;
            font-size: 12px !important;
            line-height: 17px;
            color: #000;
            margin: 0;
            margin-bottom: 5px;
          }
          p,
          a {
            font-style: normal;
            font-weight: 400 !important;
            font-size: 10px !important;
            line-height: 15px;
            color: var(--mainText);
            margin: 0;
          }
        }
        &:not(:last-child) {
          margin-bottom: 8px;
        }
      }
      .no-data {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        h4 {
          font-size: 18px !important;
        }
      }
    }
  }
  footer {
    margin-top: auto;
    text-align: center;
    border-top: 1px solid #efefef !important;
    a {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      color: var(--mainText);
    }
  }

  &.client {
    .content {
      min-height: 250px;
      max-height: 250px;
    }
  }
}
.products_states {
  header {
    .title {
      font-style: normal;
      font-weight: 600;
      font-size: 16px !important;
      line-height: 20px;
      color: #000;
      padding: 10px 0;
    }
  }
  .content {
    min-height: 350px !important;
    max-height: 350px !important;
    overflow-y: auto;
    padding-block: 8px;
    .product_card {
      border-bottom: 0.5px solid #e0e0eb;
      padding: 2px 0;
      .state {
        display: flex;
        align-items: center;
        // background: red !important;
        &:last-child {
          border-bottom: none !important;
        }

        .product_content {
          width: 100%;
          margin-inline-start: 8px;
          .title {
            display: block;
            font-style: normal;
            font-weight: 300 !important;
            font-size: 14px !important;
            line-height: 17px;
            color: #666666;
            margin: 0;
            margin-bottom: 5px;
          }
          p,
          a {
            font-style: normal;
            font-weight: 400 !important;
            font-size: 10px !important;
            line-height: 15px;
            color: var(--mainText);
            margin: 0;
          }
          .price {
            font-size: 0.9375rem !important;
            font-weight: 400;
            color: #2b3d2f !important;
            line-height: 1.375rem;
            letter-spacing: normal !important;
            text-transform: none !important;
          }
          .quantity {
            font-size: 0.8rem !important;
            font-weight: 400;
            color: #2b3d2f !important;
            line-height: 1.375rem;
            letter-spacing: normal !important;
            text-transform: none !important;
          }
        }
        &:not(:last-child) {
          margin-bottom: 8px;
        }
      }
      .no-data {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        h4 {
          font-size: 18px !important;
        }
      }
    }
  }
  footer {
    text-align: center;
    border-top: 1px solid #efefef !important;
    a {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      color: var(--mainText);
    }
  }

  &.client {
    .content {
      min-height: 250px;
      max-height: 250px;
    }
  }
}
// .cardBorder {
//   border: 1px solid var(--main);
// }
</style>
